import { render, staticRenderFns } from "./BackgroundMusic.vue?vue&type=template&id=502bbc97&scoped=true"
import script from "./BackgroundMusic.vue?vue&type=script&lang=js"
export * from "./BackgroundMusic.vue?vue&type=script&lang=js"
import style0 from "./BackgroundMusic.vue?vue&type=style&index=0&id=502bbc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502bbc97",
  null
  
)

export default component.exports